var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Invoices_Normal"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoices_Normal",
    clipPath: "url(#clip-Invoices_Normal)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Invoices",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_40",
    "data-name": "Subtraction 40",
    d: "M-1150.784-576.31h-14.835A1.382,1.382,0,0,1-1167-577.69v-22.93a1.382,1.382,0,0,1,1.381-1.38h19.517a1.382,1.382,0,0,1,1.381,1.38v15.927a5.834,5.834,0,0,0-.964-.08,5.774,5.774,0,0,0-5.767,5.767,5.78,5.78,0,0,0,.668,2.7Zm-12.309-5.818a.621.621,0,0,0-.62.62.621.621,0,0,0,.62.62h6.589a.621.621,0,0,0,.62-.62.621.621,0,0,0-.62-.62Zm0-4.264a.621.621,0,0,0-.62.62.621.621,0,0,0,.62.62h9.581a.621.621,0,0,0,.62-.62.621.621,0,0,0-.62-.62Zm.015-4.265a.621.621,0,0,0-.62.62.621.621,0,0,0,.62.62h14a.621.621,0,0,0,.62-.62.621.621,0,0,0-.62-.62Zm12.062-7.522a1.015,1.015,0,0,0-1.085,1.163v2.155c0,.825.34,1.209,1.07,1.209.989,0,1.116-.679,1.116-1.271v-.233l-.015.015h-.853v.373c0,.265-.038.419-.232.419-.161,0-.232-.124-.232-.4v-2.326c0-.235.038-.372.232-.372s.232.136.232.372v.373h.853v-.279C-1149.931-597.5-1150.043-598.18-1151.016-598.18Zm-4.527-.015a1.071,1.071,0,0,0-1.147,1.225v2.077c0,.835.36,1.24,1.1,1.24.8,0,1.178-.394,1.178-1.24v-2.047l.016-.015a1.324,1.324,0,0,0-.292-.924A1.115,1.115,0,0,0-1155.543-598.195Zm-6.247,1.659h.015c.014.061.032.155.053.279l0,.008,0,.009,0,.015c.02.111.043.236.065.34l.481,2.185h.946v-4.4h-.791v.714c0,.607.03,1.392.077,2h-.015c-.025-.17-.084-.49-.155-.791l-.45-1.938h-.93v4.4l-.015.015h.775v-.76c0-.7-.031-1.577-.061-2.076Zm2.17-1.581.666,4.4h1.1l.652-4.4h-.884l-.14,1.643c-.067.641-.125,1.215-.155,1.752h-.031c-.02-.365-.058-.754-.092-1.1-.022-.22-.045-.453-.063-.671l-.155-1.628h-.9Zm10.34,0v4.4h1.814l.093-.744h-1.07v-1.193h.9l.016-.015v-.744h-.9v-.961h.961v-.744Zm-4.4,0v4.4h.837v-4.4Zm-10.449,0v4.4h.837v-4.4Zm8.573,3.752c-.18,0-.279-.149-.279-.419v-2.248c0-.286.089-.419.279-.419s.279.129.279.419v2.248C-1155.28-594.506-1155.374-594.365-1155.559-594.365Z",
    transform: "translate(1167.62 602.62)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_41",
    "data-name": "Subtraction 41",
    d: "M-1149.773-575.054h-14.5a2.722,2.722,0,0,1-2.729-2.708v-21.53a2.722,2.722,0,0,1,2.729-2.708h18.061a2.722,2.722,0,0,1,2.729,2.708v7.7a.619.619,0,0,1-.62.616.618.618,0,0,1-.62-.616v-7.7a1.477,1.477,0,0,0-1.473-1.477h-18.061a1.484,1.484,0,0,0-1.488,1.477v21.53a1.484,1.484,0,0,0,1.488,1.477h13.818a5.755,5.755,0,0,0,.664,1.23Zm6.291-8.88h0a5.768,5.768,0,0,0-1.239-.21v-2.729a.618.618,0,0,1,.62-.616.619.619,0,0,1,.62.616v2.938Z",
    transform: "translate(1167 602)",
    fill: "#6f8b8f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2136",
    "data-name": "Group 2136",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4681",
    "data-name": "Path 4681",
    d: "M21.79,15.586a.622.622,0,0,1-.62-.62V14.64a.62.62,0,1,1,1.24,0v.326A.622.622,0,0,1,21.79,15.586Z",
    transform: "translate(1.092 -2.084)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2137",
    "data-name": "Group 2137",
    transform: "translate(15.545 17.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4689",
    "data-name": "Path 4689",
    d: "M23.348,30.275a6.387,6.387,0,0,1-5.953-8.7,6.306,6.306,0,0,1,3.38-3.535,6.387,6.387,0,0,1,8.418,3.271h0a6.387,6.387,0,0,1-3.271,8.418A6.292,6.292,0,0,1,23.348,30.275Zm-.016-11.519a5.128,5.128,0,0,0-4.682,7.209,5.136,5.136,0,1,0,4.682-7.224Z",
    transform: "translate(-16.959 -17.499)",
    fill: "#6f8b8f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4690",
    "data-name": "Path 4690",
    d: "M21.342,25.562v-.6a1.674,1.674,0,0,1-1.612-1.4h1.132c.109.341.388.6,1.054.6.5,0,.713-.2.713-.45,0-.264-.124-.419-1.1-.6-1.24-.264-1.674-.76-1.674-1.411s.419-1.256,1.426-1.4v-.5h.961v.5c1.039.155,1.426.791,1.457,1.287H22.583c-.062-.2-.186-.5-.9-.5-.558,0-.667.233-.667.419,0,.248.186.388.977.543,1.535.295,1.845.853,1.845,1.5s-.45,1.256-1.519,1.4v.6h-.961Z",
    transform: "translate(0.145 0.997)",
    fill: "#6f8b8f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesNormal);
export default __webpack_public_path__ + "static/media/Invoices_Normal.08a8f4835fd62f40b979ee6cfe4061b2.svg";
export { ForwardRef as ReactComponent };